import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faComments,
  faMagnifyingGlassChart,
  faSitemap,
  faPenRuler,
  faRocket,
  faArrowsRotate,
} from "@fortawesome/free-solid-svg-icons";
import "./Process.css";

const steps = [
  {
    step: "01",
    title: "Discovery",
    desc: "We learn about your business, goals, and audience so every decision has a clear direction from day one.",
    icon: faComments,
  },
  {
    step: "02",
    title: "Audit & Review",
    desc: "If you have an existing site, we review it to find what's working, what's not, and where to improve.",
    icon: faMagnifyingGlassChart,
  },
  {
    step: "03",
    title: "Strategy & Structure",
    desc: "We map out the page layout, user journey, and content plan before building anything.",
    icon: faSitemap,
  },
  {
    step: "04",
    title: "Design & Build",
    desc: "We design and develop a clean, responsive website focused on performance, clarity, and conversions.",
    icon: faPenRuler,
  },
  {
    step: "05",
    title: "Test & Launch",
    desc: "We test speed, responsiveness, and every key function — then launch with confidence.",
    icon: faRocket,
  },
  {
    step: "06",
    title: "Support & Growth",
    desc: "We stay involved after launch to improve, update, and grow the site alongside your business.",
    icon: faArrowsRotate,
  },
];

const Process = () => {
  return (
    <section className="processV2">
      <div className="processV2-wrap">
        <header className="processV2-head">
          <span className="processV2-tag">The Process</span>
          <h2>
            From first conversation
            <span>to your live, polished website</span>
          </h2>
          <p>
            A clear, structured process that keeps things transparent and on
            track — so you always know exactly where things stand and what
            comes next.
          </p>
        </header>

        <div className="processV2-grid">
          {steps.map((step) => (
            <article className="processV2-card" key={step.step}>
              <div className="processV2-top">
                <div className="processV2-icon">
                  <FontAwesomeIcon icon={step.icon} />
                </div>
                <span className="processV2-step">{step.step}</span>
              </div>

              <div className="processV2-content">
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
